import { action } from '@ember/object';
import type Owner from '@ember/owner';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { ImageCropperProps } from '@databox/ember-integrations/lib/components/ImageCropper/ImageCropper';
import ImageCropper from '@databox/ember-integrations/lib/components/ImageCropper/ImageCropper';

import type { ImageCropData, ReactIntegrations, Service } from 'webapp-types';

import didInsert from 'webapp/modifiers/did-insert';
import willDestroy from 'webapp/modifiers/will-destroy';

interface Args {
	image: string; // url or base64
	crop: ImageCropData | null;
	imageAspect?: number;
	onImageCrop: (image: string, crop?: ImageCropData) => void;
}

export default class CommonImageUploadCropComponent extends Component<Args> {
	@service('react') declare reactService: Service.React;

	reactElement: ReactIntegrations.Root = null;

	constructor(owner: Owner, args: Args) {
		super(owner, args);
	}

	@action
	onCropChange(image: string, crop?: ImageCropData) {
		this.args.onImageCrop(image, crop);
	}

	@action
	setupView(node: HTMLElement) {
		this.reactElement = this.reactService.create(node as HTMLDivElement);

		const props: ImageCropperProps = {
			image: this.args.image,
			crop: this.args.crop || undefined,
			aspect: this.args.imageAspect,
			onChange: this.onCropChange,
		};
		this.reactService.render(this.reactElement, ImageCropper(props));
	}

	@action
	teardownView() {
		this.reactService.unmount(this.reactElement);
	}
	<template><div {{didInsert this.setupView}} {{willDestroy this.teardownView}} /></template>
}
